import { Form, Input } from "decorator-form";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import Forum from "../entity/Forum";
import InputType from "../../../common/form/InputType";
import {IMenuPage} from "../../../common/form/fields/PageField";

const forumSelect = EntitySelect.registered({entity: Forum, type: 'many'}, 'string');

@Form({title: "Categories Panel Config"})
export default class CategoriesPanelConfig {

	@Input({type: forumSelect, title: "Forum"})
	public forum: string;

	@Input({ type: InputType.PAGE, title: "Target Page" })
	public path?: IMenuPage;
}



// WEBPACK FOOTER //
// ./src/panels/forum/config/CategoriesPanelConfig.ts